import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { DEFAULT_TEAM_SLUG, playerDisplayNameToPathSlug } from '../utils/playerProfile';

/**
 * Redirects old `/player/:playerName` URLs to `/team/:team/:playerSlug`.
 */
const LegacyPlayerRedirect: React.FC = () => {
  const { playerName } = useParams<{ playerName: string }>();
  const slug = playerDisplayNameToPathSlug(playerName ?? '');
  if (!slug) {
    return <Navigate to="/player-stats" replace />;
  }
  return <Navigate to={`/team/${DEFAULT_TEAM_SLUG}/${slug}`} replace />;
};

export default LegacyPlayerRedirect;
